import { format, parseISO } from 'date-fns';

export const formatDate = (date, fmt = 'MMM dd, yyyy') => {
  if (!date) return '';
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : new Date(date);
    return format(dateObj, fmt);
  } catch {
    return '';
  }
};

export const formatDateTime = (date, fmt = 'MMM dd, yyyy HH:mm') => {
  if (!date) return '';
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : new Date(date);
    return format(dateObj, fmt);
  } catch {
    return '';
  }
};

export const getStatusColor = (status) => {
  const colors = {
    new: 'var(--status-new)',
    documents_uploaded: 'var(--status-documents-uploaded)',
    in_process: 'var(--status-in-process)',
    application_in_process: 'var(--status-in-process)',
    verification_started: 'var(--status-verification-started)',
    pending_clarification: 'var(--status-pending-clarification)',
    completed: 'var(--status-completed)',
    closed: 'var(--status-closed)',
  };
  return colors[status] || 'var(--text-gray)';
};

export const getStatusBgColor = (status) => {
  const colors = {
    new: 'rgba(59, 130, 246, 0.1)',
    documents_uploaded: 'rgba(139, 92, 246, 0.1)',
    in_process: 'rgba(245, 158, 11, 0.1)',
    application_in_process: 'rgba(245, 158, 11, 0.1)',
    verification_started: 'rgba(234, 179, 8, 0.1)',
    pending_clarification: 'rgba(239, 68, 68, 0.1)',
    completed: 'rgba(16, 185, 129, 0.1)',
    closed: 'rgba(107, 114, 128, 0.1)',
  };
  return colors[status] || 'rgba(107, 114, 128, 0.1)';
};

export const getStatusBadgeClass = (status) => {
  const classes = {
    new: 'status-new',
    documents_uploaded: 'status-documents-uploaded',
    in_process: 'status-in-process',
    application_in_process: 'status-application-in-process',
    verification_started: 'status-verification-started',
    pending_clarification: 'status-pending-clarification',
    completed: 'status-completed',
    closed: 'status-closed',
  };
  return classes[status] || 'status-new';
};


export const parseApplicationData = (text) => {
  if (!text) return null;

  const lines = text.split('\n').map((line) => line.trim()).filter(Boolean);
  const data = {};

  // Known field labels (for multi-line matching where label is on one line, value on next)
  const knownLabels = {
    'Case ID': 'source_case_id',
    'Applicant Name': 'applicant_name',
    'College Name': 'college_name',
    'College Location': 'college_location',
    'Campus Name': 'campus_name',
    'Education Type': 'education_type',
    'Father Name': 'father_name',
    'Mother Name': 'mother_name',
    'Date of Birth': 'date_of_birth',
    'Course Name': 'course_name',
    'Register / Roll No': 'register_roll_no',
    'Year of Admission': 'year_of_admission',
    'Year of Graduation': 'year_of_graduation',
    'Email': 'email',
    'Mobile': 'mobile',
    'Alternate contact or watsapp number': 'alternate_contact',
    'Applicant Created': 'applicant_created',
    'Apply Date': 'apply_date',
    'Apply With': 'apply_with',
    'Apply For': 'apply_for',
    'Expected Date': 'expected_date',
    'Student Comments': 'student_comments',
    'Indicate the which document required': 'document_required',
    'Delivery Address': 'delivery_address',
    'Reference Number': 'reference_number',
  };

  // Colon-separated regex patterns (original format: "Field Name: Value")
  const fieldPatterns = [
    { pattern: /^Case\s+ID\s*[:\-]\s*(.+?)(?:\s*\(|$)/i, key: 'source_case_id' },
    { pattern: /^Applicant\s+Name\s*[:\-]?\s*(.+)$/i, key: 'applicant_name' },
    { pattern: /^College\s+Name\s*[:\-]?\s*(.+)$/i, key: 'college_name' },
    { pattern: /^College\s+Location\s*[:\-]?\s*(.+)$/i, key: 'college_location' },
    { pattern: /^Campus\s+Name\s*[:\-]?\s*(.+)$/i, key: 'campus_name' },
    { pattern: /^Education\s+Type\s*[:\-]?\s*(.+)$/i, key: 'education_type' },
    { pattern: /^Father\s+Name\s*[:\-]?\s*(.+)$/i, key: 'father_name' },
    { pattern: /^Mother\s+Name\s*[:\-]?\s*(.+)$/i, key: 'mother_name' },
    { pattern: /^Date\s+of\s+Birth\s*[:\-]?\s*(.+)$/i, key: 'date_of_birth' },
    { pattern: /^Course\s+Name\s*[:\-]?\s*(.+)$/i, key: 'course_name' },
    { pattern: /^Register\s*\/\s*Roll\s+No\s*[:\-]?\s*(.+)$/i, key: 'register_roll_no' },
    { pattern: /^Year\s+of\s+Admission\s*[:\-]?\s*(.+)$/i, key: 'year_of_admission' },
    { pattern: /^Year\s+of\s+Graduation\s*[:\-]?\s*(.+)$/i, key: 'year_of_graduation' },
    { pattern: /^Email\s*[:\-]?\s*(.+)$/i, key: 'email' },
    { pattern: /^Mobile\s*[:\-]?\s*(.+)$/i, key: 'mobile' },
    { pattern: /^Alternate\s+contact\s+or\s+watsapp\s+number\s*[:\-]?\s*(.+)$/i, key: 'alternate_contact' },
    { pattern: /^Applicant\s+Created\s*[:\-]?\s*(.+)$/i, key: 'applicant_created' },
    { pattern: /^Apply\s+Date\s*[:\-]?\s*(.+)$/i, key: 'apply_date' },
    { pattern: /^Apply\s+With\s*[:\-]?\s*(.+)$/i, key: 'apply_with' },
    { pattern: /^Apply\s+For\s*[:\-]?\s*(.+)$/i, key: 'apply_for' },
    { pattern: /^Expected\s+Date\s*[:\-]?\s*(.+)$/i, key: 'expected_date' },
    { pattern: /^Student\s+Comments\s*[:\-]?\s*(.+)$/i, key: 'student_comments' },
    { pattern: /^Indicate.*document.*required\s*[:\-]?\s*(.+)$/i, key: 'document_required' },
    { pattern: /^Delivery\s+Address\s*[:\-]?\s*(.+)$/i, key: 'delivery_address' },
    { pattern: /^Reference\s+Number\s*[:\-]?\s*(.+)$/i, key: 'reference_number' },
  ];

  // First try: colon-separated format (e.g., "Applicant Name: Sanjay")
  for (const { pattern, key } of fieldPatterns) {
    for (const line of lines) {
      const match = line.match(pattern);
      if (match) {
        let value = match[1].trim();
        if (key === 'college_name' && value.includes('Ime')) {
          value = value.replace(/Ime\s*\(\s*/, '').replace(/\s*\).*/, '');
        }
        data[key] = value;
        break;
      }
    }
  }

  // If colon format found enough fields, return
  if (Object.keys(data).length >= 3) {
    return data;
  }

  // Second try: multi-line format (label on one line, value on next line)
  // Build a normalized lookup: lowercase trimmed label -> key
  const labelLookup = {};
  for (const [label, key] of Object.entries(knownLabels)) {
    labelLookup[label.toLowerCase().replace(/\s+/g, ' ')] = key;
  }

  for (let i = 0; i < lines.length - 1; i++) {
    const normalizedLine = lines[i].toLowerCase().replace(/\s+/g, ' ');
    if (labelLookup[normalizedLine]) {
      const key = labelLookup[normalizedLine];
      let value = lines[i + 1].trim();
      // Make sure the value isn't itself a known label
      const nextNorm = value.toLowerCase().replace(/\s+/g, ' ');
      if (!labelLookup[nextNorm] && value) {
        if (key === 'college_name') {
          // Extract university name from parentheses if present
          const uniMatch = value.match(/\(([^)]+)\)/);
          data['university_name'] = uniMatch ? uniMatch[1].trim() : '';
          // Clean college name - keep as-is but strip "( University)" suffix for college_name
          data[key] = value.replace(/\s*\([^)]*\)\s*$/, '').trim() || value;
        } else {
          data[key] = value;
        }
        i++; // skip the value line
      }
    }
  }

  return Object.keys(data).length > 0 ? data : null;
};


export const generateCaseNumber = () => {
  const timestamp = Date.now().toString().slice(-8);
  const random = Math.floor(Math.random() * 10000)
    .toString()
    .padStart(4, '0');
  return `UCP-${timestamp}-${random}`;
};

export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const debounce = (fn, delay = 300) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
};

export const getFileIcon = (fileName) => {
  const ext = fileName?.split('.')?.pop()?.toLowerCase() || '';
  const iconMap = {
    pdf: '📄',
    doc: '📝',
    docx: '📝',
    xls: '📊',
    xlsx: '📊',
    jpg: '🖼️',
    jpeg: '🖼️',
    png: '🖼️',
    gif: '🖼️',
    zip: '📦',
    rar: '📦',
    txt: '📄',
    csv: '📊',
  };
  return iconMap[ext] || '📎';
};

export const capitalizeWords = (str) => {
  if (!str) return '';
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
  }
  return phone;
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const getRelativeTime = (date) => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : new Date(date);
  const now = new Date();
  const diff = now - dateObj;

  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;

  return formatDate(date, 'MMM dd, yyyy');
};
